import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import ServiceFeedbackModal from "../../../components/Modal/ServiceFeedback/ServiceFeedbackModal";

const BookingCard = ({ booking }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  console.log("BookingCard booking", booking);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  // const handleDownloadInvoice = async () => {
  //   toast.info(`Downloading invoice `);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/wallet/invoice/${booking.uuid}`,
  //       { responseType: "blob" }
  //     );

  //     const url = window.URL.createObjectURL(new Blob([response.data]));

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `invoice_${booking.uuid}.pdf`);
  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Error downloading the invoice:", error);
  //   }
  // };

  const handleDownloadInvoice = async () => {
    setInvoiceLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/wallet/invoice/${booking.uuid}`,
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice_${booking.uuid}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the invoice:", error);
    } finally {
      setInvoiceLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <figure className="pt-3">
        <div className="space-y-2">
          <h1 className="font-semibold text-base">#BKID-{booking.id}</h1>
          <p className="font-semibold text-base">{booking.service_quote.summary}</p>
          <p className="flex items-center space-x-1 text-sm">{booking.service_quote.description}</p>
          <p className="flex items-center space-x-1 text-sm">Service Id:- #SQ-{booking.service_quote.id}</p>
          <p className="flex items-center space-x-1 text-sm">Service:- {booking.service.name}</p>
          <p className="flex items-center space-x-1 text-sm">
            <FaRegCalendarAlt size={12} />
            <span>
              Booked on {moment(booking.created_at).format("Do MMMM YYYY")}
            </span>
          </p>
          <div className="space-y-2">
            <p className="flex items-center space-x-1 text-sm">
              Total Amount = Rs.{" "}
              {parseInt(booking.total_amount).toLocaleString("en-IN")}
            </p>
            <p className="flex items-center space-x-1 text-sm">
              Paid = Rs.{" "}
              {parseInt(booking.total_paid).toLocaleString("en-IN")}
            </p>
          </div>
          <span className="flex items-center space-x-2">
            <p className="flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit">
              {booking?.service_quote?.work_status && (
                <span
                  className={`px-2 py-1 text-white rounded text-xs ${{
                    NEW_WORK: 'bg-green-600',
                    EXISTING_WORK: 'bg-yellow-600',
                    HALF_DONE: 'bg-orange-600',
                  }[booking.service_quote.work_status] || 'bg-gray-400'
                    }`}
                >
                  {booking.service_quote.work_status.replace('_', ' ').toLowerCase()}
                </span>
              )}
            </p>

            <p className="flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit">
              {booking?.status && (
                <span
                  className={`px-2 py-1 text-white rounded text-xs ${{
                    PAYMENT_PENDING: 'bg-yellow-600',
                    CONFIRMED: 'bg-blue-600',
                    WORKING: 'bg-blue-600',
                    COMPLETED: 'bg-green-600',
                    CANCELLED: 'bg-red-600',
                    REQUEST_TO_CLOSE: 'bg-orange-500',
                  }[booking.status] || 'bg-gray-400'
                    }`}
                >
                  {booking.status === 'REQUEST_TO_CLOSE'
                    ? 'Request to Close'
                    : booking.status.replace('_', ' ').toLowerCase()}
                </span>
              )}
            </p>
          </span>
          {/* this badge for status */}

          <div className="py-2 flex flex-col sm:flex-row justify-between items-start">
            <div className="flex flex-col sm:flex-row">
              <Link
                to={`/dashboard/booking/${booking.uuid}`}
                className="btn-primary-sm"
              >
                View Booking Details
              </Link>

              {/* {booking.status === "COMPLETED" && (
                <button
                  onClick={handleDownloadInvoice}
                  className="btn-primary-sm mt-2 sm:mt-0 sm:ml-2"
                >
                  Download Invoice
                </button>
              )} */}
              {booking.status === "COMPLETED" && (
                <button
                  onClick={handleDownloadInvoice}
                  className="btn-primary-sm mt-2 sm:mt-0 sm:ml-2 flex items-center justify-center"
                  disabled={invoiceLoading}
                >
                  {invoiceLoading ? (
                    <span className="flex items-center space-x-2">
                      <svg
                        className="animate-spin h-4 w-4 text-white"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8z"
                        ></path>
                      </svg>
                      <span>Downloading...</span>
                    </span>
                  ) : (
                    "Download Invoice"
                  )}
                </button>
              )}
            </div>

            <div className="mt-1 sm:mt-0 sm:ml-4 w-full sm:w-auto">
              {booking.status === "COMPLETED" && (
                <div className="flex flex-col">
                  <Link
                    onClick={() => setIsModalOpen(true)}
                    className="relative hidden md:block" // Hide on small screens, show on md and above
                    style={{ color: "black" }} // Text color
                  >
                    Review
                    <span
                      className="absolute left-0 right-0 bottom-[-5px] h-[2px] bg-[rgba(255,238,2,255)]"
                      style={{ marginTop: "3px" }} // Space between text and underline
                    />
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div>
            {booking.status === "COMPLETED" && (
              <Link
                onClick={() => setIsModalOpen(true)}
                className="mt-2 sm:mt-2 md:hidden relative" // Show only on small devices
                style={{ color: "black" }} // Text color
              >
                Review
                <span
                  className="absolute left-0 right-0 bottom-[-5px] h-[2px] bg-[rgba(255,238,2,255)]"
                  style={{ marginTop: "3px" }} // Space between text and underline
                />
              </Link>
            )}

            <ServiceFeedbackModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              serviceId={booking.service.id}
              userId={booking.service_quote.user_id} // Pass user_id to modal
            />
          </div>

        </div>
      </figure>
    </React.Fragment>
  );
};

const Booking = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/service-quote-booking`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (response.data.status) {
        setBookings(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <figure className="border shadow-lg">
        <div className="px-5 py-4 space-y-1 border-b">
          <h1 className="text-base font-medium">My Bookings</h1>
          <p className="text-xs text-gray-500">List of all your bookings</p>
        </div>
        <div className="p-5 pt-1 space-y-3 divide-y">
          {loading ? (
            <div
              style={{
                height: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="spinner"></div>
            </div>
          ) : bookings.length === 0 ? (
            <div className="text-center text-sm text-gray-500 py-10">No data found</div>
          ) : (
            bookings
              .map((booking) => (
                <BookingCard key={booking.id} booking={booking} />
              ))
          )}
        </div>
      </figure>
    </React.Fragment>
  );
};

export default Booking;
